import React, { PropTypes } from 'react';
import { Button } from 'react-bootstrap';
import InnerGlyphicon from './InnerGlyphicon';
import '../../styles/ObservationHeader';
import FeedbackButton from './FeedbackButton';

let ObservationHeader = React.createClass({
	propTypes: {
		confirmDone: PropTypes.func.isRequired,
		currentCycleNumber: PropTypes.number,
		handleUndo: PropTypes.func.isRequired,
		isTimerRunning: PropTypes.bool,
		numberOfCycles: PropTypes.number,
		timer: PropTypes.string,
		toggleTimer: PropTypes.func.isRequired,
		totalTime: PropTypes.string,
	},

	handleUndo: function(ev) {
		this.props.handleUndo();
		// TODO: feedback
	},

	canRequestFullscreen: function() {
		let { documentElement } = document;

		return (
			documentElement && (
				documentElement.requestFullscreen ||
				documentElement.webkitRequestFullScreen ||
				documentElement.mozRequestFullScreen ||
				documentElement.msRequestFullscreen
			)
		);
	},

	toggleFullscreen: function(ev) {
		if (this.isFullscreen()) {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			}
			if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			}
			if (document.mozExitFullscreen) {
				document.mozExitFullscreen();
			}
			if (document.msExitFullscreen) {
				document.msExitFullscreen();
			}
		} else {
			let element = document.documentElement;

			let requestFullscreen = element.requestFullscreen ||
				element.webkitRequestFullscreen ||
				element.mozRequestFullscreen ||
				element.msRequestFullscreen;

			requestFullscreen.call(element);
		}
	},

	isFullscreen: function(ev) {
		if (
			document.fullscreenElement ||
			document.webkitFullscreenElement ||
			document.mozFullscreenElement ||
			document.msFullscreenElement
		) {
			return true;
		} else {
			return false;
		}
	},

	render: function() {
		let {
			confirmDone,
			currentCycleNumber,
			isTimerRunning,
			numberOfCycles,
			timer,
			toggleTimer,
			totalTime
		} = this.props;

		return(
			<div className="observation-header">
				{
					this.canRequestFullscreen() ? (
						<button
							className={ 'toggle-fullscreen btn btn-success ' + (this.isFullscreen() ? 'active' : '') }
							onClick={ this.toggleFullscreen }
						>
							<i className="glyphicon glyphicon-fullscreen" />
						</button>
					) : ''
				}
				<div className="observation-timer-container">
					<div className="observation-cycles">Cycle { currentCycleNumber } of { numberOfCycles }</div>
					<button
						className={ 'pause-observation btn ' + (isTimerRunning ? 'btn-info' : 'btn-primary') }
						onClick={ toggleTimer }
					>
						<i className={ 'glyphicon glyphicon-' + (isTimerRunning ? 'pause' : 'play') } />
					</button>
					<div className="observation-timer">{ timer } of { totalTime }</div>
				</div>
				<div className="observation-controls">
					<FeedbackButton
						className="btn btn-default undo-button"
						onClick={ this.handleUndo }
						innerHTML={
							<span>
								<i className="glyphicon glyphicon-step-backward" />
								{' '}
								Undo last action
							</span>
						}
					>
					</FeedbackButton>
					{' '}
					<button
						className="btn btn-warning"
						onClick={ confirmDone }
					>
					End early
					</button>
				</div>
			</div>
		);
	}
});

module.exports = ObservationHeader;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/ObservationHeader.jsx